import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../redux/store";
import { updateTimecardApprovalStatus } from "../../redux/features/schedule/ScheduleApi";
import { useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const TimesheetApprovalPage: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { approvalDetails } = useSelector((state: RootState) => state.schedule);
    const params = useParams<{ start_date: string; end_date: string; employee_id: string }>();
    const [notes, setNotes] = useState<string>("");

    const ucode = approvalDetails?.ucode; // not used in new endpoint, kept if needed later
    const start_date = params.start_date;
    const end_date = params.end_date;
    const employee_id = params.employee_id;
    const location = useLocation();
    const state = (location.state || {}) as any;
    const offCycle = !!state.offCycle;
    const wf_code = state.wf_code || (approvalDetails && (approvalDetails as any).WF_CODE);

    const handleAction = async (action: "approve" | "reject") => {
        const APPROVAL_STATUS = action === "approve" ? 1 : -1;
        if (!start_date || !end_date || !employee_id) {
            toast.error("Missing required data to submit approval");
            return;
        }
        const payload = {
            start_date,
            end_date,
            APPROVAL_STATUS,
            APPROVAL_NOTE: notes || undefined,
            EMP_IDS: [Number(employee_id)],
        };
        const resultAction = await dispatch(updateTimecardApprovalStatus(payload as any));
        const res = (resultAction as any)?.payload;
        const message = res?.message || "Updated";
        if (res?.status) {
            toast.success(message);
            navigate(-1);
        } else {
            toast.error(message || "Failed to update");
        }
    };

    return (
        <div className="container mx-auto w-full md:w-1/2 p-4">
            <div className="text-xl font-semibold mb-4">Approve / Reject Timesheets</div>
            <div className="mb-4">
                {/* <label className="block text-sm text-gray-600 mb-1">Notes (optional)</label> */}
                <label className="block text-sm text-gray-600 mb-1">Notes</label>
                <textarea
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Add notes..."
                    className="w-full border rounded-md p-3 focus:outline-none focus:ring-2 focus:ring-blue-100"
                    rows={4}
                />
            </div>
            <div className="flex space-x-3">
                <button
                    onClick={() => handleAction("approve")}
                    className="flex-1 px-4 py-3 rounded-lg border border-blue-600 text-blue-600 bg-transparent"
                >
                    Approve
                </button>
                <button
                    onClick={() => handleAction("reject")}
                    className="flex-1 px-4 py-3 rounded-lg border border-red-600 text-red-600 bg-transparent"
                >
                    Reject
                </button>
            </div>
        </div>
    );
};

export default TimesheetApprovalPage;